(function () {
  'use strict';

  /*
   * Matrice di pesi per il calcolo del profilo.
   * Chiave = internal_id della domanda (impostato nel theme editor, non modificare).
   * Ogni voce dell'array corrisponde, in ordine, a option_1, option_2, ... di quella domanda.
   * Se aggiungi/rimuovi opzioni da una domanda con scoring, aggiorna anche questa matrice.
   */
  var WEIGHTS = {
    q3: [
      { SI: 2 },
      { EP: 2 },
      { TD: 1, SS: 1 },
      { SI: 2 },
      { TD: 1, EP: 1, SI: 1, SS: 1 }
    ],
    q4: [
      { TD: 3 },
      { TD: 3 },
      { TD: 1, SS: 2 },
      { SI: 3 },
      { EP: 3 },
      { SS: 3 }
    ],
    q5: [
      {},
      { TD: 1 },
      { TD: 2, SS: 1 },
      { TD: 3, SS: 2 }
    ],
    q6: [
      { SS: 3 },
      { TD: 1, SS: 1 },
      {},
      {}
    ],
    q7: [
      { TD: 2 },
      { TD: 2 },
      { EP: 2 },
      { SI: 2 },
      { TD: 1, SS: 1 },
      { SS: 2 },
      { SS: 2 },
      { SS: 1 }
    ],
    q9: [
      { SI: 2 },
      { SI: 2 },
      { TD: 2 },
      { EP: 2 },
      { SS: 2 },
      { TD: 1, EP: 1 }
    ]
  };

  var TIE_BREAK_ORDER = ['TD', 'SS', 'EP', 'SI'];

  function trackEvent(config, name) {
    if (!config.trackingEnabled) return;
    try {
      if (typeof window.clarity === 'function') {
        window.clarity('event', name);
      }
    } catch (e) {
      /* no-op: tracking must never break the quiz */
    }
  }

  function trackSet(config, key, value) {
    if (!config.trackingEnabled) return;
    try {
      if (typeof window.clarity === 'function') {
        window.clarity('set', key, value);
      }
    } catch (e) {
      /* no-op */
    }
  }

  function createIconSvg() {
    var svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
    svg.setAttribute('viewBox', '0 0 24 24');
    svg.setAttribute('fill', 'none');
    svg.setAttribute('stroke', 'currentColor');
    svg.setAttribute('stroke-width', '3');
    var path = document.createElementNS('http://www.w3.org/2000/svg', 'path');
    path.setAttribute('d', 'M5 13l4 4L19 7');
    svg.appendChild(path);
    return svg;
  }

  function QuizInstance(root) {
    this.root = root;
    var configScript = root.querySelector('script[data-qz-config]');
    this.config = JSON.parse(configScript.textContent);
    this.questions = this.config.questions || [];
    this.preloadImages(); 
    this.profiles = this.config.profiles || {};
    this.answers = {};
    this.currentIndex = 0;
    this.els_card = root.querySelector('[data-qz-card]');
    this.reducedMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;    this.pendingIntermediateFor = null;

    this.els = {
      progressFill: root.querySelector('[data-qz-progress-fill]'),
      screens: {
        question: root.querySelector('[data-qz-screen="question"]'),
        intermediate: root.querySelector('[data-qz-screen="intermediate"]'),
        loading: root.querySelector('[data-qz-screen="loading"]'),
        result: root.querySelector('[data-qz-screen="result"]')
      },
      stepLabel: root.querySelector('[data-qz-step-label]'),
      questionTitle: root.querySelector('[data-qz-question-title]'),
      options: root.querySelector('[data-qz-options]'),
      continueBtn: root.querySelector('[data-qz-continue]'),
      backBtn: root.querySelector('[data-qz-back]'),
      intermediateImage: root.querySelector('[data-qz-intermediate-image]'),
      intermediateText: root.querySelector('[data-qz-intermediate-text]'),
      intermediateContinue: root.querySelector('[data-qz-intermediate-continue]'),
      loadingTitle: root.querySelector('[data-qz-loading-title]'),
      loadingSubtitle: root.querySelector('[data-qz-loading-subtitle]'),
      resultEyebrow: root.querySelector('[data-qz-result-eyebrow]'),
      resultName: root.querySelector('[data-qz-result-name]'),
      resultDescription: root.querySelector('[data-qz-result-description]'),
      resultHighlight: root.querySelector('[data-qz-result-highlight]'),
      cta: root.querySelector('[data-qz-cta]')
    };

    this.bindStaticEvents();
    trackEvent(this.config, 'quiz_start');
    this.renderQuestion();
  }
  

  QuizInstance.prototype.preloadImages = function () {
    this.questions.forEach(function (q) {
      if (q.intermediate && q.intermediate.enabled && q.intermediate.image) {
        var img = new Image();
        img.src = q.intermediate.image;
      }
    });
  };

  QuizInstance.prototype.bindStaticEvents = function () {
    var self = this;
    this.els.continueBtn.addEventListener('click', function () {
      self.handleContinue();
    });
    this.els.backBtn.addEventListener('click', function () {
      self.handleBack();
    });
  };

  QuizInstance.prototype.showScreen = function (name) {
    var screens = this.els.screens;
    Object.keys(screens).forEach(function (key) {
      if (!screens[key]) return;
      screens[key].hidden = key !== name;
    });
  };
  
  QuizInstance.prototype.crossFade = function (fn) {
  if (this.reducedMotion || !this.els_card) { fn(); return; }
  var card = this.els_card;
  card.classList.add('qz-card--fading');
  setTimeout(function () {
    fn();
    requestAnimationFrame(function () {
      card.classList.remove('qz-card--fading');
    });
  }, 400);
};

  QuizInstance.prototype.updateProgress = function () {
    if (!this.els.progressFill) return;
    var total = this.questions.length;
    var pct = total ? Math.round(((this.currentIndex) / total) * 100) : 0;
    this.els.progressFill.style.width = pct + '%';
  };

  QuizInstance.prototype.renderQuestion = function () {
    var q = this.questions[this.currentIndex];
    if (!q) {
      this.finishQuiz();
      return;
    }
    this.updateProgress();
    this.showScreen('question');

    this.els.stepLabel.textContent = 'Domanda ' + (this.currentIndex + 1) + ' di ' + this.questions.length;
    this.els.questionTitle.textContent = q.text;

    var isMulti = q.type === 'multiple';
    var existing = this.answers[q.id] || [];
    var optionsWrap = this.els.options;
    optionsWrap.innerHTML = '';

    q.options.forEach(function (label, idx) {
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'qz-option';
      btn.setAttribute('data-qz-multi', isMulti ? 'true' : 'false');
      btn.setAttribute('data-index', String(idx));
      if (existing.indexOf(idx) !== -1) btn.classList.add('is-selected');

      var marker = document.createElement('span');
      marker.className = 'qz-option-marker';
      marker.appendChild(createIconSvg());

      var text = document.createElement('span');
      text.textContent = label;

      btn.appendChild(marker);
      btn.appendChild(text);
      optionsWrap.appendChild(btn);
    });

    var self = this;
    optionsWrap.querySelectorAll('.qz-option').forEach(function (btn) {
      btn.addEventListener('click', function () {
        self.handleOptionClick(q, btn);
      });
    });

    this.els.backBtn.style.visibility = this.currentIndex === 0 ? 'hidden' : 'visible';

    if (isMulti) {
      this.els.continueBtn.style.display = '';
      this.refreshContinueState(q);
    } else {
      this.els.continueBtn.style.display = 'none';
    }
  };

  QuizInstance.prototype.handleOptionClick = function (q, btn) {
    var idx = parseInt(btn.getAttribute('data-index'), 10);
    var isMulti = q.type === 'multiple';
    var current = this.answers[q.id] ? this.answers[q.id].slice() : [];

    if (isMulti) {
      var pos = current.indexOf(idx);
      if (pos === -1) {
        current.push(idx);
      } else {
        current.splice(pos, 1);
      }
    } else {
      current = [idx];
    }

    this.answers[q.id] = current;

    var options = this.els.options.querySelectorAll('.qz-option');
    options.forEach(function (o) {
      var oIdx = parseInt(o.getAttribute('data-index'), 10);
      o.classList.toggle('is-selected', current.indexOf(oIdx) !== -1);
    });

    if (isMulti) {
      this.refreshContinueState(q);
    } else {
      var self = this;
      setTimeout(function () {
        self.proceedFromQuestion(q);
      }, 350);
    }
  };

  QuizInstance.prototype.refreshContinueState = function (q) {
    var answered = this.answers[q.id] && this.answers[q.id].length > 0;
    this.els.continueBtn.disabled = !answered;
  };

  QuizInstance.prototype.handleContinue = function () {
    var q = this.questions[this.currentIndex];
    if (!q || !this.answers[q.id] || !this.answers[q.id].length) return;
    this.proceedFromQuestion(q);
  };

  QuizInstance.prototype.proceedFromQuestion = function (q) {
    trackEvent(this.config, 'quiz_question_answered_' + q.id);

    var self = this;
    this.crossFade(function () {
      if (q.intermediate && q.intermediate.enabled) {
        self.showIntermediate(q);
      } else {
       self.advance();
      }
    });
  };

  QuizInstance.prototype.showIntermediate = function (q) {
    this.showScreen('intermediate');

    if (q.intermediate.image) {
      this.els.intermediateImage.hidden = false;
      this.els.intermediateImage.innerHTML = '<img src="' + q.intermediate.image + '" alt="" loading="lazy">';
    } else {
      this.els.intermediateImage.hidden = true;
      this.els.intermediateImage.innerHTML = '';
    }

    this.els.intermediateText.textContent = q.intermediate.text || '';
    this.els.intermediateContinue.textContent = q.intermediate.buttonLabel || 'Continua';
  
    var self = this;
  this.els.intermediateContinue.onclick = function () {
    self.crossFade(function () {
      self.advance();
    });
  };
};
  QuizInstance.prototype.advance = function () {
    this.currentIndex += 1;
    if (this.currentIndex >= this.questions.length) {
      this.finishQuiz();
    } else {
      this.renderQuestion();
    }
  };

  QuizInstance.prototype.handleBack = function () {
  if (this.currentIndex === 0) return;
  var self = this;
  this.crossFade(function () {
    self.currentIndex -= 1;
    self.renderQuestion();
  });
};

  QuizInstance.prototype.computeScores = function () {
    var totals = { TD: 0, EP: 0, SI: 0, SS: 0 };
    var self = this;

    this.questions.forEach(function (q) {
      if (!q.hasScoring) return;
      var selected = self.answers[q.id] || [];
      var weightsForQ = WEIGHTS[q.id];
      if (!weightsForQ) return;

      selected.forEach(function (idx) {
        var w = weightsForQ[idx];
        if (!w) return;
        Object.keys(w).forEach(function (key) {
          totals[key] = (totals[key] || 0) + w[key];
        });
      });
    });

    return totals;
  };

  QuizInstance.prototype.resolveProfileKey = function (totals) {
    var best = null;
    var bestScore = -Infinity;

    TIE_BREAK_ORDER.forEach(function (key) {
      var score = totals[key] || 0;
      if (score > bestScore) {
        bestScore = score;
        best = key;
      }
    });

    return best || TIE_BREAK_ORDER[0];
  };

  QuizInstance.prototype.finishQuiz = function () {
    this.updateProgress();
    trackEvent(this.config, 'quiz_completed');

    var totals = this.computeScores();
    var profileKey = this.resolveProfileKey(totals);
    trackSet(this.config, 'quiz_profile', profileKey);

    var self = this;

    if (this.config.loadingEnabled) {
      this.showScreen('loading');
      this.els.loadingTitle.textContent = this.config.loadingTitle || '';
      this.els.loadingSubtitle.textContent = this.config.loadingSubtitle || '';
      var seconds = this.config.loadingDuration || 3;
          setTimeout(function () {
      self.crossFade(function () {
        self.renderResult(profileKey);
      });
    }, seconds * 1000);
    } else {
      this.renderResult(profileKey);
    }
  };

  QuizInstance.prototype.renderResult = function (profileKey) {
    var profile = this.profiles[profileKey] || {};
    this.showScreen('result');

    this.els.resultEyebrow.textContent = this.config.resultEyebrow || '';
    this.els.resultName.textContent = profile.name || '';
    this.els.resultDescription.textContent = profile.description || '';
    this.els.resultHighlight.textContent = this.config.resultHighlight || '';

    var url = this.config.productUrl || '#';
    var separator = url.indexOf('?') === -1 ? '?' : '&';
    var finalUrl = url + separator + 'ref=quiz&profile=' + encodeURIComponent(profileKey);
    this.els.cta.setAttribute('href', finalUrl);

    var self = this;
    this.els.cta.addEventListener('click', function () {
      trackEvent(self.config, 'quiz_cta_click');
    });
  };

  window.ZhenziQuiz = {
    instances: [],
    init: function (root) {
      if (!root || root.hasAttribute('data-qz-initialized')) return;
      root.setAttribute('data-qz-initialized', 'true');
      var instance = new QuizInstance(root);
      window.ZhenziQuiz.instances.push(instance);
    }
  };
})();